export const CREATE_ORDER_DELIVERY_SCHEDULE = 'CREATE_ORDER_DELIVERY_SCHEDULE';
export const UPDATE_ORDER_DELIVERY_SCHEDULE = 'UPDATE_ORDER_DELIVERY_SCHEDULE';
export const DELETE_ORDER_DELIVERY_SCHEDULE = 'DELETE_ORDER_DELIVERY_SCHEDULE';
export const ORDER_DELIVERY_SCHEDULE_REQUEST = 'ORDER_DELIVERY_SCHEDULE_REQUEST';
export const ORDER_DELIVERY_SCHEDULE_REQUEST_SUCCESS = 'ORDER_DELIVERY_SCHEDULE_REQUEST_SUCCESS';
export const ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE = 'ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE';